module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-200italic.d7bbb730d9b5e11720b3eb32326dcca7.woff";